import { render } from "./AddInfoForm.vue?vue&type=template&id=3fa16722&scoped=true"
import script from "./AddInfoForm.vue?vue&type=script&lang=js"
export * from "./AddInfoForm.vue?vue&type=script&lang=js"

import "./AddInfoForm.vue?vue&type=style&index=0&id=3fa16722&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fa16722"]])

export default __exports__